"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const core_1 = require("@angular/core");
const http_1 = require("@angular/http");
const common_1 = require("../../../@inax/common");
const domain_1 = require("./domain");
const alarmConfig_1 = require("./config/alarmConfig");
let InaxAlarmService = InaxAlarmService_1 = class InaxAlarmService {
    constructor(_http, _configuration, _profileService, _alarmConfig) {
        this._http = _http;
        this._configuration = _configuration;
        this._profileService = _profileService;
        this._alarmConfig = _alarmConfig;
        this._changeEvent = new core_1.EventEmitter();
    }
    get hubName() {
        return "AlarmHub";
    }
    get dataChangeIsAvailable() {
        return InaxAlarmService_1._callbackAvailable;
    }
    /***********************************************************************
     *          SIGNALR
     * ********************************************************************/
    registerEvents(signalR) {
        if (this._configuration.UseSignalR && this._configuration.EnabledSignalRHubs.indexOf(this.hubName) >= 0) {
            InaxAlarmService_1._hubProxy = signalR.getHubProxy(this.hubName);
            InaxAlarmService_1._hubProxy.on("alarmListChanged", () => {
                this._changeEvent.emit(new domain_1.AlarmListChangeEvent());
            });
            InaxAlarmService_1._callbackAvailable = true;
        }
    }
    get ChangeEvent() { return this._changeEvent; }
    /***********************************************************************
     *          WEB API
     * ********************************************************************/
    numberOfAlarmsAsync(filter = "") {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.numberOfAlarms(filter).toPromise();
        });
    }
    numberOfAlarms(filter = "") {
        let accessUrl = this._configuration.buildRestUrl(InaxAlarmService_1._alarmControllerName, "NumberOfAlarmEntries");
        if (filter != null && filter.length > 0)
            accessUrl += "?filter=" + filter;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.get(accessUrl, { headers }).map(res => res.json());
    }
    numberOfHistoricalAlarmsAsync(filter = "") {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.numberOfHistoricalAlarms(filter).toPromise();
        });
    }
    numberOfHistoricalAlarms(filter = "") {
        let accessUrl = this._configuration.buildRestUrl(InaxAlarmService_1._alarmControllerName, "NumberOfHistoricalAlarmEntries");
        if (filter != null && filter.length > 0)
            accessUrl += "?filter=" + filter;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.get(accessUrl, { headers }).map(res => res.json());
    }
    alarmsAsync(filter = "", fromLcid = "", toLcid = "", skip = 0, take = 100, reverse = false, orderBy = "") {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.alarms(filter, fromLcid, toLcid, skip, take, reverse, orderBy).toPromise();
        });
    }
    alarms(filter = "", fromLcid = "", toLcid = "", skip = 0, take = 100, reverse = false, orderBy = "") {
        let accessUrl = this._configuration.buildRestUrl(InaxAlarmService_1._alarmControllerName, "Alarms") +
            this.createQueryParams(filter, fromLcid, toLcid, skip, take, reverse, orderBy);
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.get(accessUrl, { headers }).map(res => res.json()).map(x => {
            let res = x;
            return res != null ? this._alarmConfig.applyConfigSettingsOnAlarms(x.Entries) : [];
        });
    }
    historyAsync(filter = "", fromLcid = "", toLcid = "", skip = 0, take = 100, reverse = false, orderBy = "") {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.history(filter, fromLcid, toLcid, skip, take, reverse, orderBy).toPromise();
        });
    }
    history(filter = "", fromLcid = "", toLcid = "", skip = 0, take = 100, reverse = false, orderBy = "") {
        let accessUrl = this._configuration.buildRestUrl(InaxAlarmService_1._alarmControllerName, "AlarmHistory") +
            this.createQueryParams(filter, fromLcid, toLcid, skip, take, reverse, orderBy);
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.get(accessUrl, { headers }).map(res => res.json()).map(x => {
            let res = x;
            return res != null ? this._alarmConfig.applyConfigSettingsOnAlarms(x.Entries) : [];
        });
    }
    createQueryParams(filter = "", fromLcid = "", toLcid = "", skip = 0, take = 100, reverse = false, orderBy = "") {
        let queryParams = "?";
        if (filter != null && filter.length > 0)
            queryParams += "filter=" + filter + " AND " + this._alarmConfig.createActiveAlarmFilterByConfigSettings();
        else
            queryParams += this._alarmConfig.createActiveAlarmFilterByConfigSettings();
        queryParams += "fromLcid=" + fromLcid + "&toLcid=" + toLcid + "&skip=" + skip + "&take=" + take + "&reverse=" + reverse;
        if (orderBy != null && orderBy.length > 0)
            queryParams += "&orderBy=" + orderBy;
        return queryParams;
    }
    normalizeUri(uri) {
        return encodeURIComponent(uri);
    }
};
InaxAlarmService._subscribers = new Array();
InaxAlarmService._alarmControllerName = "AlarmManagement";
InaxAlarmService._callbackAvailable = false;
InaxAlarmService = InaxAlarmService_1 = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http,
        common_1.InaxConfiguration,
        common_1.ProfileService,
        alarmConfig_1.InaxAlarmConfig])
], InaxAlarmService);
exports.InaxAlarmService = InaxAlarmService;
var InaxAlarmService_1;
